export default __webpack_public_path__ + "static/media/Amna Čukurija.19b5f282.jpg";